<main class="panel-viewport">

  <section centerPane>
    <h2>Available Subscriptions</h2>
    @if (products) {
      <table>
        <tr>
          <th>Product</th>
          <th>Categories</th>
          <th>SKU</th>
          <th>Duration</th>
          <th>Product Status</th>
          <th>Price</th>
          <th>Purchase</th>
        </tr>
        @for (item of products; track item) {
          <tr>
            <td>{{item.title}}</td><td>{{item.category}}</td>
            <td>{{item.sku}}</td>
            <td>{{item.moduleDetail?.duration}}</td>
            <td>{{item.status}}</td>
            <td>${{item.price | number:'1.2-2'}}</td>
            <td>
              @if (isAdmin()) {
                <span>
                  <button mat-flat-button color="primary" name="xferbutton" (click)="onClickSubscribe(item)"> Subscribe </button> &nbsp;
                </span>
              }
              @if (item.status=='publish') {
                <span>
                  <a href="https://bodyof9.com/product/{{item.name}}" target="_blank" rel="noopener">Buy Now</a>
                </span>
              }
            </td>
          </tr>
        }
      </table>
    }
    <hr>
      <h2>Subscriptions for {{ name }}</h2>
      @if (userD) {
        <table>
          <tr>
            <th>Order ID</th>
            <th>Product</th>
            <th>Categories</th>
            <th>Duration</th>
            <th>Selected</th>
            <th>Order Status</th>
            <th>Start</th>
            <th>End</th>
            <th>Cancel</th>
          </tr>
          @for (item of userD; track item; let i = $index) {
            @if (item.userData) {

            <tr>
              <td>{{item.orderId}}</td>
              <td>{{item.productInfo.title}}</td>
              <td>{{item.productInfo.category}}</td>
              <td>{{item.userData.duration}}</td>
              <td>{{item.userData.selectList}}</td>
              <td>{{item.userData.status}}</td>
              <td>{{dateFormating(item.userData.date_started, "ts")}}</td>
              <td>{{dateFormating(item.userData.date_end, "ts") }}</td>
              <td>
                @if (item.userData.status!='Cancelled') {
                  <span>	<button mat-flat-button color="primary" name="xferbutton" (click)="onClickDelete(item,item.productIndex, item.orderIndex)"> Cancel </button></span>
                }
              </td>
            </tr>
           }
          }
        </table>
      }
    </section>
  </main>
